export { SignUpCTA } from './element'

export interface IProps {
  buttonLabel: string
  placeholderText: string
  errorText: string
  small?: boolean
  collapsedLabel?: string
  forceBusinessEmail?: boolean
  businessEmailErrorMessage?: string
  pricingTabId?: number
  entryDescriptionRequired?: string
  elementLocation?: string
  marketoFormId: string
  showSuccessMessage?: boolean
  eventContext?: string
  url?: string
}
